import React from "react";

const ADO_Recordset = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Recordset</h1>
      <p>This is the ADO Recordset page content.</p>
    </div>
  );
};

export default ADO_Recordset;
